import { Column } from 'src/shared/components/Semantic/all'

export const HeaderSection = () => {
  return (
    <Column className="gap-2 text-center">
      <h1>Validate your information</h1>
      <p className="text-muted-foreground">
        Please review and confirm your company and personal information.
      </p>
    </Column>
  )
}

